import { HistoryOutlined } from "@ant-design/icons";
import SummaryWrapper from "../SummaryWrapper";
import {
  getLabelTag,
  getLabelTagInput,
  getLabelTagsArray,
  getLabelTagYesNO,
  getPastMedicalHistorySummary,
} from "../constructTextFromValues";
import {
  alcoholOptions,
  appetiteOptions,
  foodPreferenceOptions,
  gLSymptomsTimelineOptions,
  gLSymptomsTypeOptions,
  metabolicStressOptions,
  nutritionistFunctionalOptions,
  nutritionistPastMedicalOptions,
  smokingOptions,
} from "../../Options/historyOptions";
import { habitOptions } from "../../../OpEMR/Physiotherapist/Forms/OpPhysioOptions";

const NutritionistHistorySummary = ({ formData }) => {
  const constructHistorySummaryItems = () => {
    const historySummaryItems = [];
    const pushHistoryItem = (key, label, children) => {
      historySummaryItems.push({ key, label, children });
    };
    const history = formData?.history || {};
    if (
      getPastMedicalHistorySummary(nutritionistPastMedicalOptions, history)
        ?.length > 0
    ) {
      pushHistoryItem(
        "1",
        "Past Medical History",
        getPastMedicalHistorySummary(nutritionistPastMedicalOptions, history)
      );
    }
    if (history?.allergy_details?.food_allergies) {
      pushHistoryItem(
        "2",
        "Food Allergies",
        <>
          {getLabelTagYesNO(history?.allergy_details?.food_allergies)}
          {getLabelTagInput(
            "Details",
            history?.allergy_details?.allergy_description
          )}
        </>
      );
    }
    if (history?.food_preferences) {
      pushHistoryItem(
        "3",
        "Food Preferences",
        <>
          {getLabelTag(foodPreferenceOptions, history?.food_preferences)}
          {getLabelTagInput("Others Details", history?.food_preferences_others)}
        </>
      );
    }
    if (history?.functional_capacity) {
      pushHistoryItem(
        "4",
        "Functional Capacity",
        getLabelTag(nutritionistFunctionalOptions, history?.functional_capacity)
      );
    }
    if (history?.metabolic_stress) {
      pushHistoryItem(
        "5",
        "Metabolic Stress",
        getLabelTag(metabolicStressOptions, history?.metabolic_stress)
      );
    }
    if (history?.appetite_prior_to_admission) {
      pushHistoryItem(
        "6",
        "Appetite Prior to Admission",
        getLabelTag(appetiteOptions, history?.appetite_prior_to_admission)
      );
    }
    if (history?.gl_symptoms_details?.symptoms_timeline) {
      pushHistoryItem(
        "7",
        "GL Symptoms",
        <>
          {getLabelTag(
            gLSymptomsTimelineOptions,
            history?.gl_symptoms_details?.symptoms_timeline
          )}
          {getLabelTagsArray(
            gLSymptomsTypeOptions,
            history?.gl_symptoms_details?.symptoms
          )}
        </>
      );
    }
    if (
      history?.smoking ||
      history?.alcohol ||
      history?.life_style ||
      history?.habits_comments
    ) {
      pushHistoryItem(
        "8",
        "Habits",
        <>
          {getLabelTagInput(
            "Smoking",
            getLabelTag(smokingOptions, history?.smoking)
          )}
          {getLabelTagInput(
            "Alcohol",
            getLabelTag(alcoholOptions, history?.alcohol)
          )}
          {getLabelTagInput(
            "Life Style",
            getLabelTag(habitOptions, history?.life_style)
          )}
          {getLabelTagInput("Habits Remarks", history?.habits_comments)}
        </>
      );
    }
    return historySummaryItems;
  };
  const historySummaryItems = constructHistorySummaryItems();
  return (
    <SummaryWrapper
      items={historySummaryItems}
      title={
        <span style={{ fontWeight: "normal" }}>
          <HistoryOutlined style={{ color: "var(--ant-primary-color)" }} /> History
        </span>
      }
    />
  );
};

export default NutritionistHistorySummary;
